import React from 'react';
import { Box, Typography } from '@mui/material';
import heroGroup from '../assets/hero-group.png';

export default function HeroSection() {
  return (
    <Box sx={{ 
      bgcolor: '#fff', 
      // Match HeaderSection inner container horizontal padding
      px: { xs: 2.5, sm: 3, md: 3, lg: 15 },
      // Add sufficient top padding so content sits below the absolute-positioned HeaderSection
      pt: { xs: 8, sm: 12, md: 12, lg: 20 },
      maxWidth: '1900px',
      margin: '0 auto'
    }}>
      <Box sx={{ 
        width: '100%',
        borderRadius: '19px',
        overflow: 'hidden',
        mb: { xs: 3, sm: 4 }
      }}>
        <Box
          component="img"
          src={heroGroup}
          alt="Ixoria Doctors"
          sx={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
      </Box>

      <Typography
        align="center"
        variant="h4"
        sx={{
          color: '#222',
          fontSize: { xs: 16, sm: 28, md: 40, lg: 55 },
          px: { xs: 2, sm: 6, md: 10, lg: 18 },
          fontWeight: 400,
          lineHeight: { xs: 1.25, sm: 1.3, md: 1.38 },
          letterSpacing: 0.5,
          mb: { xs: 2, sm: 3, md: 3, lg: 3 },
          // mt:{ xs:10}
        }}
      >
        An Ayurvedic doctor crew helping you{' '}
        <Box component="span" sx={{ fontWeight: 500, display: 'inline', color: '#111', whiteSpace: 'nowrap' }}>
          heal acne inside-out
        </Box>
        {' '}with diet, lifestyle, and the right medicine.
      </Typography>
    </Box>
  );
}
